import React, { Component } from "react"
import { TableDistratosDigitalizados } from "./"
import Layout from "../../Layout"
import Moment from "moment"
import { Loading, HttpError } from "../../../components"
import Util from "../../../Util"
import * as ApiHelper from "../../../ApiHelper"
export default class DistratosDigitalizados extends Component {
  constructor() {
    super()
    this.getDistratosDigitalizados = this.getDistratosDigitalizados.bind(this)
    this.filter = this.filter.bind(this)
    this.state = {
      distratosDigitalizados: [],
      initialDistratosDigitalizados: [],
      showTable: false
    }
  }
  componentWillMount() {
    this.getDistratosDigitalizados()
  }
  getDistratosDigitalizados() {
    ApiHelper.getDistratosDigitalizados(
      this.props.match.params.id,
      (distratosDigitalizados, error) => {
        if (distratosDigitalizados) {
          console.log(distratosDigitalizados)
          this.setState({
            distratosDigitalizados: distratosDigitalizados,
            initialDistratosDigitalizados: distratosDigitalizados,
            showTable: true
          })
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialDistratosDigitalizados.filter(contrato => {
      return (
        Util.getLastPathComponent(contrato.nome)
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(contrato.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      distratosDigitalizados: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Distratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Distratos">
        {this.state.showTable ? (
          <TableDistratosDigitalizados
            filter={this.filter}
            onDelete={this.getDistratosDigitalizados}
            sizeClass=""
            title="Distratos digitalizados"
            subtitle="Listagem de todos os distratos digitalizados"
            backgroundColor="as-blue"
            rows={this.state.distratosDigitalizados}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/distratos/digitalizados/DistratosDigitalizados.js